export default __webpack_public_path__ + "static/media/noIncidents.18f44d53.svg";